<template>
  <div>
    <div class="search-row">
      <div>
        <el-input
          clearable
          placeholder="请输入物料编码"
          v-model="params.itemCode"
        />
        <el-input
          clearable
          placeholder="请输入物料名称"
          v-model="params.itemName"
        />
        <el-button class="btn-red-plain" size="small" @click="handleFilter"
          >搜索</el-button
        >
        <el-button class="btn-red-plain" size="small" @click="handleReset"
          >重置</el-button
        >
      </div>
      <div>
        <el-button class="btn-red-plain" size="small" @click="handleImport"
          >导入价格</el-button
        >
        <el-button class="btn-red-plain" size="small" @click="handleExport"
          >导出明细</el-button
        >
        <el-button class="btn-red-plain" size="small" @click="handleCreate"
          >+新建</el-button
        >
      </div>
    </div>
    <v-form ref="materialForm" :url="exportUrl" :params="params" />
    <import-file-dialog ref="importFile" />
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import vForm from '@/components/v-form'
import ImportFileDialog from './import-file'
export default {
  name: 'search-row',
  components: {
    vForm,
    ImportFileDialog
  },
  data () {
    return {
      params: {
        itemName: '',
        itemCode: ''
      },
      exportUrl: commonUtils.getApiUrl('/trade/item/export/priceRegion')
    }
  },
  created () {},
  methods: {
    setUserParams (val) {
      this.params = val
    },
    // 搜索
    handleFilter () {
      this.$emit('onFilter', this.params)
    },

    // 重置
    handleReset () {
      this.params = this.$options.data().params
      this.$emit('onReset')
    },

    // 导入价格
    handleImport () {
      this.$refs.importFile.show()
    },

    // 导出明细
    handleExport () {
      this.$confirm('是否根据当前条件导出明细?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$refs.materialForm.submit()
        })
        .catch(() => {})
    },

    // 新建
    handleCreate () {
      this.$router.push({
        path: '/bcc/material/info',
        query: {
          type: 'create'
        }
      })
    }
  }
}
</script>

<style lang="scss">
.search-row {
  display: flex;
  justify-content: space-between;
  .el-input {
    width: 180px;
    margin-right: $content-middle;
  }
}
</style>
